export const getThemeLocalStorage = () => {
  return localStorage.getItem('theme') || 'light-theme';
};

export const setThemeLocalStorage = (theme) => {
  localStorage.setItem('theme', theme);
};

export const parseToQuerystringTarget = (arr = []) => {
  if (arr) {
    return arr
      .map((el) => `${el.contactField}=${encodeURIComponent(el.valueContactField)}`)
      .join('&');
  }

  return [];
};
